<template>
    <div>
        <div v-if="extrasLoading" style="min-height: 20vh" class="d-flex justify-content-center align-items-center">
            <div class="spinner-border" style="border: 0.25em solid rgb(61, 197, 214); border-right-color: transparent" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div class="table-responsive" v-if="!extrasLoading">
            <table v-if="typeof this.extras.data !== 'undefined' && this.extras.data.length > 0"
                   class="table table-hover table-nowrap">
                <thead class="thead-light">
                <tr>
                    <th scope="col">{{ $t('Image') }}</th>
                    <th scope="col">{{ $t('Name') }}</th>
                    <th scope="col">{{ $t('Price') }}</th>
                    <th scope="col">{{ $t('Discount') }}</th>
                    <th scope="col">{{ $t('Duration') }}</th>
                    <th scope="col">{{ $t('Max quantity') }}</th>
                    <th scope="col">{{ $t('Assigned to') }}</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in this.extras.data" :key="item.id" class="text-heading font-semibold">
                    <td>
                        <img :src="item.photo_path" class="img-fluid" style="max-width: 100px" v-if="item.photo_path">
                        <span v-else>{{ $t('N/A') }}</span>
                    </td>
                    <td class="text-wrap">
                        {{ item.name }}
                    </td>
                    <td>
                        {{ currencySymbol }}{{ item.price }}
                    </td>
                    <td>
                        {{ item.discount }}
                    </td>
                    <td>
                        {{ item.title.replace('No wait time', '0 min.') }}
                    </td>
                    <td>
                        {{ item.extra_max_quantity }}
                    </td>
                    <td>
                        <a href="#" class="text-primary" :id="item.id" @click="item.expanded = !item.expanded" v-if="item.services.length">
                            {{ !item.expanded ? 'Expand all' : 'Collapse all' }}
                        </a>
                        <span v-else>{{ $t('None') }}</span>

                        <ul v-if="item.expanded">
                            <li v-for="service in item.services">{{ service.name }}</li>
                        </ul>
                    </td>
                    <td class="text-end" v-if="!archived">
                        <button :id="item.id" class="btn btn-outline-primary btn-sm px-3 assign-to-all-services" @click="assignAll">
                            {{ $t('Assign to all services') }}
                        </button>
                        <button :id="item.id" class="btn btn-outline-primary btn-sm px-3 edit-extra ms-2" @click="edit">
                            {{ $t('Edit') }}
                        </button>
                    </td>
                    <td class="text-end" v-else>
                        <button :id="item.id" class="btn btn-outline-primary btn-sm px-3 restore-extra ms-2" @click="restore">
                            {{ $t('Restore') }}
                        </button>
                    </td>
                    <td class="text-end">
                        <div class="form-check form-check-inline mx-3">
                            <input class="form-check-input" type="checkbox" :value="item.id" v-model="checked">
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <span v-else>{{ $t('No extra services.') }}</span>
        </div>
        <div v-if="!extrasLoading && typeof this.extras.data !== 'undefined' && this.extras.data.length > 0">
            <div class="row mt-1 py-3">
                <div class="col-8">
                    <div class="d-flex align-items-center justify-content-center ml-4">
                        <div class="per-page-selector d-flex align-items-center">
                            <label for="per-page" class="text-nowrap mr-2 mb-0 text-primary">{{ $t('Show:') }}&nbsp;&nbsp;</label>
                            <select v-model="paginate" class="form-select form-select-sm text-primary" id="per-page">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="30">50</option>
                                <option value="100">100</option>
                                <option value="1000">1000</option>
                            </select>
                        </div>
                        <Bootstrap4Pagination
                            :data="extras"
                            :showDisabled="true"
                            :limit="1"
                            :loading="extrasLoading"
                            @pagination-change-page="getExtras">
                            <template v-slot:prev-nav>
                                <span>{{ $t('Back') }}</span>
                            </template>
                            <template v-slot:next-nav>
                                <span>{{ $t('Next') }}</span>
                            </template>
                        </Bootstrap4Pagination>
                    </div>
                </div>
                <div class="col-4 d-flex justify-content-end">
                    <a style="border:1px solid"
                       title="Archive selected extra services."
                       class="btn"
                       :class="{disabled: checked.length === 0}"
                       @click="archiveMulti();"
                        v-if="!archived">
                        {{ $t('Archive') }}
                    </a>
                    <a style="border:1px solid"
                       title="Restore selected extra services."
                       class="btn"
                       :class="{disabled: checked.length === 0}"
                       @click="restoreMulti();"
                       v-else>
                        {{ $t('Restore') }}
                    </a>
                    <a style="border:1px solid"
                       title="Delete selected extra services."
                       class="btn ms-2"
                       :class="{disabled: checked.length === 0}"
                       @click="deleteMulti();">
                        {{ $t('Delete') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-mask" v-if="showModal">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{{ $t('Edit') }} {{ extra.name }}</h5>
                    <button type="button" class="btn-close" @click="this.showModal=false;" aria-label="Close"></button>
                </div>
                <div class="modal-body pt-0">
                    <div class="row">
                        <div class="col-12 mt-5 mb-5">
                            <label class="form-label" for="title">{{ $t('Title') }}:</label>
                            <input type="text" class="form-control" id="name" name="name" :placeholder="$t('Title')" v-model="extra.name">
                        </div>
                        <div class="col-md-12 mb-5">
                            <label class="form-label">{{ $t('Image') }}</label>
                            <div class="mb-2" v-if="extra.photo_path && showImagePreview">
                                <img :src="extra.photo_path" alt="" class="d-block mb-1" style="max-width:100px">
                                <a href="#" @click="removeImage" class="text-primary text-sm">{{ $t('Remove') }}</a>
                            </div>
                            <input id="extra_image" type="file" class="form-control" name="image" accept="image/*" @change="imageChange">
                            <div class="mt-2 note form-label">{{ $t('Square (1:1) format is recommended') }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <label class="form-label" for="price">{{ $t('Price') }} ({{ currencySymbol }})</label>
                            <input type="text" class="form-control" id="price" name="price" :placeholder="$t('Price')" max="9999" onkeypress='validateNumAndSpecChars(event)' v-model="extra.price">
                        </div>
                        <div class="col-md-2">
                            <label class="form-label" for="discount">{{ $t('Discount') }} (%)</label>
                            <input type="text" class="form-control" id="discount" name="discount" :placeholder="$t('Discount')" max="100" onkeypress='validateNumAndSpecChars(event)' v-model="extra.discount">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label" for="durations">{{ $t('Duration') }}</label>
                            <select class="form-select" id="durations" name="duration" v-model="extra.duration">
                                <option v-for="duration in durations" :value="duration.id">
                                    {{ duration.title.replace('No wait time', '0 min.') }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label" for="qty">{{ $t('Max. quantity') }}</label>
                            <input type="text" class="form-control" id="qty" name="qty" placeholder="Quantity" min="1" max="100" onkeyup="validateMin(event)" onkeypress='validateNumAndSpecChars(event)' v-model="extra.extra_max_quantity">
                        </div>
                    </div>
                </div>
                <div class="modal-footer px-8 pb-8">
                    <button type="submit" class="btn btn-success" @click="save">{{ $t('Save') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    overflow: scroll;
}
.form-check-input {
    width: 30px;
    height: 30px;
}
</style>

<script>
import Form from "../helpers/Form";
import Notification from "../helpers/Notification.vue";
import LocationSettings from "../helpers/LocationSettings.vue";

export default {
    mixins: [Form, LocationSettings],
    props: {
        archived: Boolean
    },
    data: function () {
        return {
            extras: [],
            paginate: 20,
            extra: {},
            durations: [],
            showModal: false,
            showImagePreview: true,
            currencySymbol: window.currencySymbol,
            expanded: [],
            checked: [],
            extrasLoading: false
        }
    },
    watch: {
        paginate: function (value, oldValue) {
            this.getExtras();
        },
    },
    methods: {
        getExtras(page = 1) {
            this.extrasLoading = true;
            axios.get('/api/admin/services/extras?' +
                'page=' + page +
                '&paginate=' + this.paginate +
                '&archived=' + this.archived
            ).then(res => {
                this.extras = res.data;
                this.extras.data.map((item) => item.expanded = false);
                this.extrasLoading = false;
            });
        },
        assignAll(e) {
            let extra_service_id = e.target.id;

            if (extra_service_id > 0) {
                axios.post('/api/admin/services/extras/assign-all', {'extra_service_id': extra_service_id})
                    .then((res) => {
                        this.onSuccess(res.data.message);
                        this.getExtras();
                    })
                    .catch((error) => {
                        this.onFailure(error.response.data.message);
                    });
            }
        },
        edit(e) {
            const id = e.target.id;

            this.showModal = true;

            axios
                .get(`/api/admin/extras/${id}`)
                .then(res => {
                    this.extra = res.data.data;
                    this.extra.duration = this.extra.time_intervals_id;
                    this.extra.photo_changed = false;
                    this.showImagePreview = true;
                });
        },
        save() {
            this.extra.qty = this.extra.extra_max_quantity;

            let data = new FormData();
            data.append('name',this.extra.name);
            data.append('price', this.extra.price);
            data.append('duration', this.extra.duration);
            data.append('discount', this.extra.discount);
            data.append('qty', this.extra.qty);

            if (this.extra.photo_changed) {
                data.append('photo_path', this.extra.photo_path);
                data.append('photo_changed', this.extra.photo_changed);
            }

            axios
                .post(`/api/admin/extras/update/${this.extra.id}`, data, {
                    headers: { 'content-type': 'multipart/form-data' }
                })
                .then(res => {
                    this.showModal = false;
                    this.onSuccess(res.data.message);
                    this.getExtras();
                })
                .catch((error) => {
                    if (error && error.response.status === 422) {
                        // Validation error
                        if(error.response.data.errors !== undefined) {
                            this.setErrors(error.response.data.errors);
                        } else {
                            Notification.methods.warning(error.response.data.message);
                        }
                    } else {
                        this.onFailure(error.response.data.message);
                    }
                });
        },
        getDurations() {
            axios
                .get('/api/admin/extras/durations')
                .then(res => {
                    this.durations = res.data.data;
                });
        },
        removeImage() {
            this.extra.photo_path = null;
            this.extra.photo_changed = true;
        },
        imageChange(e) {
            this.showImagePreview = false;
            this.extra.photo_path = e.target.files[0];
            this.extra.photo_changed = true;
        },
        deleteMulti() {
            deleteConfirm('', this.$t('Are you sure you want to delete selected items? This action can not be undone.'), false).then((result) => {
                let arrIds = encodeURIComponent(JSON.stringify(this.checked));

                axios
                    .delete('/api/admin/extras/delete?ids=' + arrIds)
                    .then(res => {
                        this.onSuccess(res.data.message);

                        this.checked = [];
                        this.getExtras();
                    })
                    .catch((error) => {
                        if (error && error.response.status == 422) {
                            this.setErrors(error.response.data.errors);
                        } else {
                            this.onFailure(error.response.data.message);
                        }
                    });
            });
        },
        archiveMulti() {
            archiveConfirm('', this.$t('Are you sure you want to archive selected items?'), false).then((result) => {
                let arrIds = encodeURIComponent(JSON.stringify(this.checked));

                axios
                    .post('/api/admin/extras/archive?ids=' + arrIds)
                    .then(res => {
                        this.onSuccess(res.data.message);

                        this.checked = [];
                        this.getExtras();
                    })
                    .catch((error) => {
                        if (error && error.response.status == 422) {
                            this.setErrors(error.response.data.errors);
                        } else {
                            this.onFailure(error.response.data.message);
                        }
                    });
            });
        },
        restoreMulti() {
            restoreConfirm('', this.$t('Are you sure you want to restore selected items?'), false).then((result) => {
                let arrIds = encodeURIComponent(JSON.stringify(this.checked));

                axios
                    .post('/api/admin/extras/restore?ids=' + arrIds)
                    .then(res => {
                        this.onSuccess(res.data.message);

                        this.checked = [];
                        this.getExtras();
                    })
                    .catch((error) => {
                        if (error && error.response.status == 422) {
                            this.setErrors(error.response.data.errors);
                        } else {
                            this.onFailure(error.response.data.message);
                        }
                    });
            });
        },
        restore(e) {
            const id = e.target.id;

            axios
                .get(`/api/admin/extras/restore/${id}`)
                .then(res => {
                    this.onSuccess(res.data.message);
                    this.getExtras();
                })
                .catch((error) => {
                    if (error && error.response.status == 422) {
                        this.setErrors(error.response.data.errors);
                    } else {
                        this.onFailure(error.response.data.message);
                    }
                });
        },
    },
    mounted() {
        this.getExtras();
        this.getDurations();
    }
}
</script>
